import axios from '@/libs/api.request'

export const getLaborbusinesslist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/laborbusiness/laborbusiness/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationLaborbusiness = (data, meth) => {
  return axios.request({
    url: '/v1/laborbusiness/laborbusiness/',
    method: meth,
    data
  })
}